import { render, staticRenderFns } from "./ResidentialDuplex.vue?vue&type=template&id=6d4c2a82&scoped=true&"
import script from "./ResidentialDuplex.vue?vue&type=script&lang=ts&"
export * from "./ResidentialDuplex.vue?vue&type=script&lang=ts&"
import style0 from "./ResidentialDuplex.vue?vue&type=style&index=0&id=6d4c2a82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4c2a82",
  null
  
)

export default component.exports